<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <b-card class="table-basic">
        <div class="table-header-container d-flex justify-content-between align-items-center pt-2 pb-3">
            <div class="title-container d-flex align-items-center">
                <h2 class="pr-1">{{title.georgian}}</h2>
                <span v-if="type === 'multiple'">Multiple choice</span>
                <span v-else>Single choice</span>
            </div>

            <b-button v-if="draggable" variant="flat-secondary" class="btn-icon mr-1" size="lg" @click="showModal">
                <feather-icon icon="Edit3Icon" size="18"/>
            </b-button>
        </div>

        <b-table responsive="sm"
                 :fields="columns"
                 fixed outlined
                 show-empty
                 hover
                 empty-text="ვარიანტები არ არის დამატებული"
                 class="table-basic"
                 :items="rows">
            <template #cell(georgian)="{item}" td-class="text-right">
                <b-form-input v-if="itemRow && itemRow.id === item.id" v-model="itemRow['georgian']"
                              type="text">
                </b-form-input>
                <template v-else>{{ item.georgian }}</template>
            </template>

            <template #cell(english)="{item}" td-class="text-right">
                <b-form-input v-if="itemRow && itemRow.id === item.id" v-model="itemRow['english']"
                              type="text">
                </b-form-input>
                <template v-else>{{ item.english }}</template>
            </template>

            <template #cell(actions)="{item}" td-class="text-right">
                <b-button v-if="itemRow && itemRow.id === item.id" variant="flat-success" :key="title.english + item.id"
                          class="btn-icon" @click="saveItem()">
                    <feather-icon icon="SaveIcon" size="18"/>
                </b-button>

                <b-button v-else variant="flat-secondary" :key="title.english + item.id" class="btn-icon"
                          @click="editItem(item)">
                    <feather-icon icon="Edit3Icon" size="18"/>
                </b-button>

                <b-button variant="flat-danger" class="btn-icon" :key="title.english + item.id" @click="deleteItem(item)">
                    <feather-icon icon="Trash2Icon" size="18"/>
                </b-button>
            </template>

        </b-table>

        <b-table responsive="sm"
                 thead-class="hidden_header"
                 fixed
                 hover
                 :fields="defaultFields"
                 :items="defaultRows">
        </b-table>

        <b-modal id="rearrange-modal"
                 ref="rearrange-modal"
                 size="lg"
                 class="p-6"
                 hide-header
                 hide-footer
                 centered>

            <div class="modal-custom-header mb-1 d-flex align-items-center justify-content-between">
                <!--<h4 class="mb-0">თანმიმდევრობის შეცვლა</h4>-->
                <b-button variant="primary" class="save-changes" @click="saveRearrangedItems">
                    <feather-icon icon="SaveIcon"
                                  class="mr-50"/>
                    <span class="align-middle">შეცვლილი თანმიმდევრობის შენახვა</span>
                </b-button>
                <b-button variant="flat-secondary" class="btn-icon mr-1" size="lg" @click="hideModal">
                    <feather-icon icon="XIcon" size="18"/>
                </b-button>
            </div>

            <draggable v-model="draggableRows"
                       class="list-group list-group-flush cursor-move mb-2"
                       tag="ul">
                <transition-group
                        type="transition"
                        name="flip-list">
                    <b-list-group-item
                            v-for="listItem in draggableRows"
                            :key="'draggableRows' + listItem.id + title.english"
                            tag="li">
                        <div class="d-flex align-items-center justify-content-between">
                            <b-button variant="flat-secondary" class="btn-icon btn-sm mr-1" size="xs">
                                <feather-icon icon="MoveIcon" size="12"/>
                            </b-button>
                            <span class="text-left">{{listItem.georgian}}</span>
                            <span class="text-left">{{listItem.english}}</span>
                        </div>
                    </b-list-group-item>
                </transition-group>
            </draggable>

            <draggable v-model="draggableDefaultRows"
                       class="list-group list-group-flush cursor-move"
                       tag="ul">
                <transition-group
                        type="transition"
                        name="flip-list">
                    <b-list-group-item variant="secondary"
                                       v-for="listItem in draggableDefaultRows"
                                       :key="'draggableDefaultRows' + listItem.id + title.english"
                                       tag="li">
                        <div class="d-flex align-items-center justify-content-between">
                            <b-button variant="flat-secondary" class="btn-icon btn-sm mr-1" size="xs">
                                <feather-icon icon="MoveIcon" size="12"/>
                            </b-button>
                            <span class="text-left">{{listItem.georgian}}</span>
                            <span class="text-left">{{listItem.english}}</span>
                        </div>
                    </b-list-group-item>
                </transition-group>
            </draggable>

            <div v-if="false" class="mt-3 d-flex justify-content-end align-items-center">

                <b-button variant="primary" class="save-changes mb-3" @click="saveRearrangedItems">
                    <feather-icon icon="SaveIcon"
                                  class="mr-50"/>
                    <span class="align-middle">შენახვა</span>
                </b-button>

            </div>
        </b-modal>

        <div class="card-footer-container d-flex justify-content-between align-items-center pt-2 pb-1">
            <div class="title-container d-flex align-items-center">
                <span class="text-muted">სულ {{rows.length + defaultRows.length}} ვარიანტი</span>
            </div>

            <b-button variant="primary" class="" @click="$emit('add')">
                <feather-icon icon="PlusIcon" size="18"
                              class="mr-50"/>
                <span class="align-middle">ახალი ვარიანტი</span>
            </b-button>
        </div>
    </b-card>
</template>

<script>
    import {
        BCard, BTable, BButton, BFormInput, BModal,
        BListGroupItem,
    } from "bootstrap-vue"
    import draggable from "vuedraggable"

    export default {
        components: {
            BListGroupItem,
            BCard,
            BTable,
            BButton,
            BFormInput,
            draggable,
            BModal
        },
        props: ["rows", "defaultRows", "title", "columns", "type", "draggable"],

        data() {
            return {
                itemRow: null,
                pageLength: 3,
                dir: false,
                rowsData: [],
                searchTerm: "",
                draggableRows: [],
                draggableDefaultRows: [],
                defaultFields: ["georgian", "english", "actions"],
                defaultRows1: [
                    {
                        georgian: "არ აქვს",
                        english: "None",
                        default: "",
                        _rowVariant: "secondary"
                    },
                    {
                        id: 6,
                        georgian: "სხვა",
                        english: "Other",
                        default: "",
                        _rowVariant: "secondary"

                    }
                ],
            }
        },

        watch: {
            draggableRows: function (newRows) {
                // let result = newRows.map(function(a) {return a.id;});
                // this.$emit('update', newRows.map(function(a) {return a.id;}));
            },
            rows: function () {
                if (this.draggable) {
                    this.draggableRows = this.rows;
                    this.draggableDefaultRows = this.defaultRows;
                }
            }
        },

        mounted() {
            if (this.draggable) {
                this.draggableRows = this.rows;
                this.draggableDefaultRows = this.defaultRows;
            }
        },

        methods: {

            saveRearrangedItems() {
                this.$emit("update", this.draggableRows.map(function (a) {
                    return a.id;
                }));
                this.$emit("update", this.draggableDefaultRows.map(function (a) {
                    return a.id;
                }));
                this.hideModal();
            },

            editItem(item) {
                let doEdit = true;
                if (
                    this.itemRow &&
                    !confirm(
                        "You have unsaved changes, are you sure you want to continue?"
                    )
                ) {
                    doEdit = false;
                }

                if (doEdit) {
                    this.itemRow = {...item};
                }
                // this.$emit('edit', item.item);
            },
            deleteItem(item) {
                this.$emit("delete", item);
            },

            saveItem() {
                this.itemRow.translations.forEach(el => {
                    if (el.languageCode === "ka") {el.title = this.itemRow.georgian;}
                    else {el.title = this.itemRow.english;}
                });
                this.$emit("save", this.itemRow);

                this.resetEdit();
            },

            resetEdit() {
                this.itemRow = null;
            },

            showModal() {
                this.$refs["rearrange-modal"].show();
            },

            hideModal() {
                this.$refs["rearrange-modal"].hide();
            }
        }
    }
</script>

<style>
    .hidden_header {
        display: none;
    }

    .card .table tbody tr:last-child td:first-child {
      font-weight: normal !important;
    }

    .table-basic .table td[aria-colindex='3'] {
        text-align: right;
    }

    .table-basic .table th[aria-colindex='3'] div {
        display: none;
    }

    .table-basic .table th.hide-actions {
        color: #f3f2f7;
        user-select: none;
    }


    tr {
        height: 50px;
    }

    .hidden-table tr {
        opacity: 0;
    }

    .table-responsive.hidden-table {
        position: absolute;
        transform: translateY(-100%);
        padding-bottom: 1rem;
        max-width: 70%;
    }

    .list-group-item {
        transition: all 0.2s;
    }

    .list-group span.text-left {
        width: 47%;
    }

    .modal-body {
        padding: 2rem 2.5rem;
    }

</style>
